import { Select } from '@hover/blueprint';
import React from 'react';
import { navigate } from 'gatsby';
import { HelpfulLinks } from '../../../constants';
import { IHelpFulLink } from '../../../interfaces/IHelpfulLink';

type PageName =
  | 'Trust Center'
  | 'Terms of Use'
  | 'Cookie Policy'
  | 'Privacy Policy';

interface Props {
  pageName: PageName;
}

const HelpFulLinksMobile: React.FC<Props> = ({ pageName }) => {
  const filteredLinks = HelpfulLinks.filter(link => link.label !== pageName);

  return (
    <Select
      d={{ base: 'block', tablet: 'none' }}
      placeholder="HELPFUL LINKS"
      _placeholder={{
        color: 'primary.700',
        fontWeight: 700,
      }}
      onChange={({ target: { value } }) => {
        void navigate(value);
      }}
    >
      {filteredLinks.map((link: IHelpFulLink) => (
        <option value={link.to} key={link.to}>
          {link.label}
        </option>
      ))}
    </Select>
  );
};

export default HelpFulLinksMobile;
